// services import
import { Updates } from './updates';
import { RedirectAnonymousToGateProvider } from './redirect-anonymous-to-gate';
import { AppNameProvider } from './app-name';
import { Contact } from './contact';

export const services: any[] = [
  // services export
  Updates,
  RedirectAnonymousToGateProvider,
  AppNameProvider,
  Contact,
];
